import { FilterChips } from 'shared/mui/Filter/FilterChips/FilterChips';

import { useUsersListFilterFields } from './hooks/useUsersListFilterFields';

export const UsersListFilterChips: React.FC = () => {
  const fields = useUsersListFilterFields();

  return <FilterChips fields={fields} />;
};
